



































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";
import { Department } from "../../../../../domain/department";
import { ClaioSchemaItem } from "../../../../../domain/claio";
import ClaioSchemaThumbnail from "./claio/ClaioSchemaThumbnail.vue";
import ClaioSchemaFinder from "./claio/ClaioSchemaFinder.vue";
import ClaioSchemaPreview from "./claio/ClaioSchemaPreview.vue";

@Component({
  components: {
    ClaioSchemaThumbnail,
    ClaioSchemaFinder,
    ClaioSchemaPreview,
  }
})
export default class ClaioSchemaTool extends Mixins() {
  data(): any {
    return {
      foundClaioSchemaItems: [],
      currentPage: 1,
      selectedItem: null as ClaioSchemaItem,
      selectedItemIndex: null as number,
    };
  }
  foundClaioSchemaItems: ClaioSchemaItem[];
  currentPage: number;
  selectedItem: ClaioSchemaItem;
  selectedItemIndex: number;

  // 最後に選択した画像エリアにClaio画像を貼り付ける用途がある場合は使用する
  // その用途が無い場合は不要
  @Prop()
  source: IDrawableItemEditable;

  @Prop()
  department: Department;

  @Prop()
  isVisible: boolean;

  @Prop({ default: true })
  isPastable: boolean;

  @Watch("foundClaioSchemaItems")
  onFoundClaioSchemaItemsUpdated(): void {
    this.currentPage = 1;
    this.selectedItem = null;
    this.selectedItemIndex = null;
  }

  @Watch("currentPage")
  onCurrentPageChanged(): void {
    this.selectedItemIndex = this.selectedItem
      ? this.displayClaioSchemaItems.indexOf(this.selectedItem)
      : null;
  }

  get displayClaioSchemaItems(): ClaioSchemaItem[] {
    return this.foundClaioSchemaItems.slice(this.imageCountPerPage * (this.currentPage - 1), this.imageCountPerPage * this.currentPage);
  }

  get imageCountPerPage(): number {
    return this.$configuration.behavior.document.editor.contents.schema.displayCountPerPage;
  }

  thumbnailSelected(selected: ClaioSchemaItem, index: number): void {
    this.selectedItem = selected;
    this.selectedItemIndex = index;
  }

  resetScrollPosition(): void {
    // ページ遷移が起こった時にスクロールを初期位置に戻す
    const container = this.$refs.container as HTMLDivElement;
    if (!container) { return; }
    container.scrollTop = 0;
    container.scrollLeft = 0;
  }
}
